import { MachinesState, default as machinesReducer } from "./machines";
import { AccountsState, default as accountsReducer } from "./accounts";
import { combineReducers } from "redux";

export  * from "./selectors";

export interface InfrastructureAreaState {
    machines: MachinesState;
    accounts: AccountsState;
}

export default combineReducers<InfrastructureAreaState>({
    machines: machinesReducer,
    accounts: accountsReducer
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/infrastructure/reducers/infrastructureArea.ts